<script setup lang="ts">
const { title } = defineProps<{
  title: string
}>()

// Replaces non-breaking spaces with regular spaces, so the title breaks correctly
const normalizedTitle = title.replace(/\u00A0/g, ' ')
</script>

<template>
  <section class="pt-m pb-xl">
    <div class="2xl:mx-[136px]">
      <h1 class="title-xl">
        {{ normalizedTitle }}
      </h1>
    </div>
  </section>
</template>
